// Rolling buffers of recent console errors + failed network calls, captured
// passively in the background so a beta report always carries the technical
// context leading up to it without the tester having to describe it themselves.
const MAX_ITEMS = 8;
let consoleErrors = [];
let networkFailures = [];

if (typeof window !== "undefined" && !window.__sc_beta_capture_hooked) {
  window.__sc_beta_capture_hooked = true;
  const origError = console.error;
  console.error = (...args) => {
    try {
      const msg = args
        .map((a) => (typeof a === "string" ? a : a?.message || JSON.stringify(a)))
        .join(" ")
        .slice(0, 400);
      consoleErrors.push({ message: msg, at: new Date().toISOString() });
      if (consoleErrors.length > MAX_ITEMS) consoleErrors.shift();
    } catch { /* ignore */ }
    origError.apply(console, args);
  };
}

export function recordNetworkFailure(method, url, status) {
  try {
    networkFailures.push({ method: (method || "").toUpperCase(), url: String(url || "").slice(0, 200), status: status || 0, at: new Date().toISOString() });
    if (networkFailures.length > MAX_ITEMS) networkFailures.shift();
  } catch { /* ignore */ }
}

export function getRecentConsoleErrors() {
  return [...consoleErrors];
}

export function getRecentNetworkFailures() {
  return [...networkFailures];
}
